@if (groupedBriefings) {
	@if (groupedBriefings.length === 0) {
		<empty-state data-test="empty-briefing" icon="fa fa-history" message="{{ 'briefing.empty' | translate }}" />
	} @else {
		<ul>
			@for (groupedBriefing of groupedBriefings; track groupedBriefing) {
				<li>
					<h2>
						<span>{{ groupedBriefing.resident.name }} {{ groupedBriefing.resident.firstName }}</span>
						<hr />
					</h2>

					<ul class="events">
						@for (briefing of groupedBriefing.briefings; track briefing) {
							<li>
								<ic-global-event-item
									data-test="briefing-item"
									[disableImportant]="true"
									[enableRouting]="hasRoute(briefing.type)"
									[expandNotes]="true"
									[globalEvent]="briefing"
									(selectGlobalEvent)="showDetails($event)"
								/>
							</li>
						}
					</ul>
				</li>
			}
		</ul>
	}
}
